module.exports = __webpack_public_path__ + "static/media/apple-store.4deb278d.png";